import {ChatClient} from "@smatchy/chat-client";

export class ChatInitiatedAction {
  static readonly type = '[Chat] ChatInitiatedAction';
  constructor(public payload: ChatClient) { }
}
